export const ModuleUrls = {
    MyASTM: '/MyASTM',
    MyCommmittees: '/MyASTM/MyCommittees',
    MyBallots: '/myballots',
    CommitteeBallots: '/committeeballots',
    AllOpenCommitteeBallots: '/committeeballots/all',
    MyBallotsQueueView: '/committeeballots/myBallotsQueue/View',
    ViewBallotsQueue: '/committeeballots',
    ViewClosedBallots: '/committeeballots/closedballots'
 }
 